export const COUNTRIES = {
  cl: 'cl',
  cr: 'cr',
  ar: 'ar'
};

export const TIMEZONE = {
  default: 'America/Santiago',
  cl: 'America/Santiago',
  cr: 'America/Belize',
  ar: 'America/Argentina/Buenos_Aires'
};

export const PUBLIC_CDN = process.env.REACT_APP_PUBLIC_CDN;
export const USE_SPECIAL_ENCODING = process.env.REACT_APP_USE_SPECIAL_ENCODING_DECODING === String(true);
export const DEFAULT_STORE_ID = process.env.REACT_APP_DEFAULT_STORE_ID;
export const INTERCOM_ID_MERCAT = process.env.REACT_APP_INTERCOM_ID_MERCAT;
